import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import StatusContainer from "./Body/StatusContainer/StatusContainer";
import { useStore } from "../Store";
import HeaderVolvia from "./Header/HeaderVolvia";
import StatusContainerVolvia from "./Body/StatusContainer/StatusContainerVolvia";
import HeaderPolestar from "./Header/HeaderPolestar";
import StatusContainerPolestar from "./Body/StatusContainer/StatusContainerPolestar";
import StatusContainerHedin from "./Body/StatusContainer/StatusContainerHedin";

const PageLayout = () => {
  const { casesStore } = useStore();
  const theme = casesStore.layoutTheme;

  useEffect(() => {
    document.body.style.backgroundColor = theme === "standard" ? "#f6f3f0" : "";
    return () => { document.body.style.backgroundColor = ""; };
  }, [theme]);

  switch (theme) {
    case "volvia":
      return (
        <div id="LayoutTwoContainer">
          <HeaderVolvia />
          <div id="BodyContent"><StatusContainerVolvia /></div>
          <Footer />
        </div>
      );
    case "polestar":
      return (
        <div id="LayoutTwoContainer">
          <HeaderPolestar />
          <div id="BodyContent"><StatusContainerPolestar /></div>
          <Footer />
        </div>
      );
    case "hedin":
      return (
        <div id="LayoutTwoContainer">
          <Header />
          <div id="BodyContentHedin"><StatusContainerHedin /></div>
        </div>
      );
    default:
      return (
        <div id="LayoutTwoContainer">
          <Header />
          <div id="BodyContent"><StatusContainer /></div>
          <Footer />
        </div>
      );
  }
};

export default observer(PageLayout);
